const Strings = [
    {
        "Id":1,
        "Topic": "String",
        "Problem": "Count and Say problem",
        "Done": false,
        "Bookmark": false,
        "Notes": "",
        "URL": "https://leetcode.com/problems/count-and-say/",
        "URL2": "https://www.codingninjas.com/codestudio/problems/write-as-you-speak_1090543?topList=love-babbar-dsa-sheet-problems"
    },
    {
        "Id":2,
        "Topic": "String",
        "Problem": "Transform One String to Another using Minimum Number of Given Operation",
        "Done": false,
        "Bookmark": false,
        "Notes": "",
        "URL": "https://www.geeksforgeeks.org/transform-one-string-to-another-using-minimum-number-of-given-operation/",
        "URL2": "https://www.codingninjas.com/codestudio/problems/minimum-shift-operations_1115784?topList=love-babbar-dsa-sheet-problems"
    },
    {
        "Id":3,
        "Topic": "String",
        "Problem": "Check if two given strings are isomorphic to each other",
        "Done": false,
        "Bookmark": false,
        "Notes": "",
        "URL": "https://practice.geeksforgeeks.org/problems/isomorphic-strings/0",
        "URL2": "https://www.codingninjas.com/codestudio/problems/check-if-two-given-strings-are-isomorphic-to-each-other_1117636?topList=love-babbar-dsa-sheet-problems"
    },
    {
        "Id":4,
        "Topic": "String",
        "Problem": "Recursively print all sentences that can be formed from list of word lists",
        "Done": false,
        "Bookmark": false,
        "Notes": "",
        "URL": "https://www.geeksforgeeks.org/recursively-print-all-sentences-that-can-be-formed-from-list-of-word-lists/",
        "URL2": "https://www.codingninjas.com/codestudio/problems/ninja-and-sentences_1123512?topList=love-babbar-dsa-sheet-problems"
    },
    {
        "Id":5,
        "Topic": "String",
        "Problem": "Reverse a String",
        "Done": false,
        "Bookmark": false,
        "Notes": "",
        "URL": "https://leetcode.com/problems/reverse-string/",
        "URL2": "https://www.codingninjas.com/codestudio/problems/string-reverse_3210207?topList=love-babbar-dsa-sheet-problems"
    },
    {
        "Id":6,
        "Topic": "String",
        "Problem": "Check whether a String is Palindrome or not",
        "Done": false,
        "Bookmark": false,
        "Notes": "",
        "URL": "https://practice.geeksforgeeks.org/problems/palindrome-string0817/1",
        "URL2": "https://www.codingninjas.com/codestudio/problems/check-if-the-string-is-a-palindrome_1062633?topList=love-babbar-dsa-sheet-problems"
    },
    {
        "Id":7,
        "Topic": "String",
        "Problem": "Find Duplicate characters in a string",
        "Done": false,
        "Bookmark": false,
        "Notes": "",
        "URL": "https://www.geeksforgeeks.org/print-all-the-duplicates-in-the-input-string/",
        "URL2": "https://www.codingninjas.com/codestudio/problems/duplicate-characters_3189116?topList=love-babbar-dsa-sheet-problems"
    },
    {
        "Id":8,
        "Topic": "String",
        "Problem": "Why strings are immutable in Java?",
        "Done": false,
        "Bookmark": false,
        "Notes": "",
        "URL": "https://www.baeldung.com/java-string-immutable",
        "URL2": ""
    },
    {
        "Id":9,
        "Topic": "String",
        "Problem": "Write a Code to check whether one string is a rotation of another",
        "Done": false,
        "Bookmark": false,
        "Notes": "",
        "URL": "https://www.geeksforgeeks.org/a-program-to-check-if-strings-are-rotations-of-each-other/",
        "URL2": "https://www.codingninjas.com/codestudio/problems/check-if-one-string-is-a-rotation-of-another-string_1115683?topList=love-babbar-dsa-sheet-problems"
    },
    {
        "Id":10,
        "Topic": "String",
        "Problem": "Write a Program to check whether a string is a valid shuffle of two strings or not",
        "Done": false,
        "Bookmark": false,
        "Notes": "",
        "URL": "https://www.programiz.com/java-programming/examples/check-valid-shuffle-of-strings",
        "URL2": "https://www.codingninjas.com/codestudio/problems/shuffle-two-strings_1115692?topList=love-babbar-dsa-sheet-problems"
    },
   
    {
        "Id":11,
        "Topic": "String",
        "Problem": "Write a program to find the longest Palindrome in a string.[ Longest palindromic Substring]",
        "Done": false,
        "Bookmark": false,
        "Notes": "",
        "URL": "https://practice.geeksforgeeks.org/problems/longest-palindrome-in-a-string/0",
        "URL2": "https://www.codingninjas.com/codestudio/problems/longest-palindromic-substring_758900?topList=love-babbar-dsa-sheet-problems"
    },
    {
        "Id":12,
        "Topic": "String",
        "Problem": "Find Longest Recurring Subsequence in String",
        "Done": false,
        "Bookmark": false,
        "Notes": "",
        "URL": "https://practice.geeksforgeeks.org/problems/longest-repeating-subsequence/0",
        "URL2": "https://www.codingninjas.com/codestudio/problems/longest-repeating-subsequence_1062697?topList=love-babbar-dsa-sheet-problems"
    },
    {
        "Id":13,
        "Topic": "String",
        "Problem": "Print all Subsequences of a string.",
        "Done": false,
        "Bookmark": false,
        "Notes": "",
        "URL": "https://www.geeksforgeeks.org/print-subsequences-string/",
        "URL2": "https://www.codingninjas.com/codestudio/problems/subsequences-of-string_985087?topList=love-babbar-dsa-sheet-problems"
    },
    {
        "Id":14,
        "Topic": "String",
        "Problem": "Print all the permutations of the given string",
        "Done": false,
        "Bookmark": false,
        "Notes": "",
        "URL": "https://practice.geeksforgeeks.org/problems/permutations-of-a-given-string/0",
        "URL2": "https://www.codingninjas.com/codestudio/problems/print-permutations-string_758958?topList=love-babbar-dsa-sheet-problems"
    },
    {
        "Id":15,
        "Topic": "String",
        "Problem": "Split the Binary string into two substring with equal 0’s and 1’s",
        "Done": false,
        "Bookmark": false,
        "Notes": "",
        "URL": "https://practice.geeksforgeeks.org/problems/split-the-binary-string-into-substrings-with-equal-number-of-0s-and-1s/1",
        "URL2": "https://www.codingninjas.com/codestudio/problems/sort-array-of-0s-and-1s_2656186?topList=love-babbar-dsa-sheet-problems"
    },
    {
        "Id":16,
        "Topic": "String",
        "Problem": "Word Wrap Problem [VERY IMP].",
        "Done": false,
        "Bookmark": false,
        "Notes": "",
        "URL": "https://practice.geeksforgeeks.org/problems/word-wrap/0",
        "URL2": "https://www.codingninjas.com/codestudio/problems/word-wrap_982931?topList=love-babbar-dsa-sheet-problems"
    },
    {
        "Id":17,
        "Topic": "String",
        "Problem": "EDIT Distance [Very Imp]",
        "Done": false,
        "Bookmark": false,
        "Notes": "",
        "URL": "https://practice.geeksforgeeks.org/problems/edit-distance3702/1",
        "URL2": ""
    },
    {
        "Id":18,
        "Topic": "String",
        "Problem": "Find next greater number with same set of digits. [Very Very IMP]",
        "Done": false,
        "Bookmark": false,
        "Notes": "",
        "URL": "https://practice.geeksforgeeks.org/problems/next-permutation/0",
        "URL2": ""
    },
    {
        "Id":19,
        "Topic": "String",
        "Problem": "Balanced Parenthesis problem.[Imp]",
        "Done": false,
        "Bookmark": false,
        "Notes": "",
        "URL": "https://practice.geeksforgeeks.org/problems/parenthesis-checker/0",
        "URL2": "https://www.codingninjas.com/codestudio/problems/valid-parenthesis_795104?topList=love-babbar-dsa-sheet-problems"
    },
    {
        "Id":20,
        "Topic": "String",
        "Problem": "Word break Problem[ Very Imp]",
        "Done": false,
        "Bookmark": false,
        "Notes": "",
        "URL": "https://practice.geeksforgeeks.org/problems/word-break/0",
        "URL2": "https://www.codingninjas.com/codestudio/problems/word-break-1_758963?topList=love-babbar-dsa-sheet-problems"
    },
    {
        "Id":21,
        "Topic": "String",
        "Problem": "Rabin Karp Algo",
        "Done": false,
        "Bookmark": false,
        "Notes": "",
        "URL": "https://www.geeksforgeeks.org/rabin-karp-algorithm-for-pattern-searching/",
        "URL2": "https://www.codingninjas.com/codestudio/problems/stringmatch-rabincarp_1115738?topList=love-babbar-dsa-sheet-problems"
    },
    {
        "Id":22,
        "Topic": "String",
        "Problem": "KMP Algo",
        "Done": false,
        "Bookmark": false,
        "Notes": "",
        "URL": "https://practice.geeksforgeeks.org/problems/longest-prefix-suffix2527/1",
        "URL2": "https://www.codingninjas.com/codestudio/problems/find-pattern-in-string_1112621?topList=love-babbar-dsa-sheet-problems"
    },
    {
        "Id":23,
        "Topic": "String",
        "Problem": "Convert a Sentence into its equivalent mobile numeric keypad sequence.",
        "Done": false,
        "Bookmark": false,
        "Notes": "",
        "URL": "https://www.geeksforgeeks.org/convert-sentence-equivalent-mobile-numeric-keypad-sequence/",
        "URL2": "https://www.codingninjas.com/codestudio/problems/convert-sentence_1115490?topList=love-babbar-dsa-sheet-problems"
    },
    {
        "Id":24,
        "Topic": "String",
        "Problem": "Minimum number of bracket reversals needed to make an expression balanced.",
        "Done": false,
        "Bookmark": false,
        "Notes": "",
        "URL": "https://practice.geeksforgeeks.org/problems/count-the-reversals/0",
        "URL2": "https://www.codingninjas.com/codestudio/problems/minimum-cost-to-make-string-valid_1115770?topList=love-babbar-dsa-sheet-problems"
    },
    {
        "Id":25,
        "Topic": "String",
        "Problem": "Count All Palindromic Subsequence in a given String.",
        "Done": false,
        "Bookmark": false,
        "Notes": "",
        "URL": "https://practice.geeksforgeeks.org/problems/count-palindromic-subsequences/1",
        "URL2": "https://www.codingninjas.com/codestudio/problems/count-palindrome-words-in-a-sentence_975378?topList=love-babbar-dsa-sheet-problems"
    },
    {
        "Id":26,
        "Topic": "String",
        "Problem": "Count of number of given string in 2D character array",
        "Done": false,
        "Bookmark": false,
        "Notes": "",
        "URL": "https://www.geeksforgeeks.org/find-count-number-given-string-present-2d-character-array/",
        "URL2": "https://www.codingninjas.com/codestudio/problems/count-strings_1118116?topList=love-babbar-dsa-sheet-problems"
    },
    {
        "Id":27,
        "Topic": "String",
        "Problem": "Search a Word in a 2D Grid of characters.",
        "Done": false,
        "Bookmark": false,
        "Notes": "",
        "URL": "https://practice.geeksforgeeks.org/problems/find-the-string-in-grid/0",
        "URL2": "https://www.codingninjas.com/codestudio/problems/word-search_630520?topList=love-babbar-dsa-sheet-problems"
    },
    {
        "Id":28,
        "Topic": "String",
        "Problem": "Boyer Moore Algorithm for Pattern Searching.",
        "Done": false,
        "Bookmark": false,
        "Notes": "",
        "URL": "https://www.geeksforgeeks.org/boyer-moore-algorithm-for-pattern-searching/",
        "URL2": "https://www.codingninjas.com/codestudio/problems/boyer-moore-algorithm-for-pattern-searching_1115634?topList=love-babbar-dsa-sheet-problems"
    },
    {
        "Id":29,
        "Topic": "String",
        "Problem": "Converting Roman Numerals to Decimal",
        "Done": false,
        "Bookmark": false,
        "Notes": "",
        "URL": "https://practice.geeksforgeeks.org/problems/roman-number-to-integer/0",
        "URL2": "https://www.codingninjas.com/codestudio/problems/roman-number-to-integer_981308?topList=love-babbar-dsa-sheet-problems"
    },
    {
        "Id":30,
        "Topic": "String",
        "Problem": "Longest Common Prefix",
        "Done": false,
        "Bookmark": false,
        "Notes": "",
        "URL": "https://leetcode.com/problems/longest-common-prefix/",
        "URL2": "https://www.codingninjas.com/codestudio/problems/longest-common-prefix_2090383?topList=love-babbar-dsa-sheet-problems"
    },
    {
        "Id":31,
        "Topic": "String",
        "Problem": "Number of flips to make binary string alternate",
        "Done": false,
        "Bookmark": false,
        "Notes": "",
        "URL": "https://practice.geeksforgeeks.org/problems/min-number-of-flips/0",
        "URL2": "https://www.codingninjas.com/codestudio/problems/beautiful-string_1115625?topList=love-babbar-dsa-sheet-problems"
    },
    {
        "Id":32,
        "Topic": "String",
        "Problem": "Find the first repeated word in string.",
        "Done": false,
        "Bookmark": false,
        "Notes": "",
        "URL": "https://www.geeksforgeeks.org/find-first-repeated-word-string/",
        "URL2": "https://www.codingninjas.com/codestudio/problems/second-most-repeated-word_3210218?topList=love-babbar-dsa-sheet-problems"
    },
    {
        "Id":33,
        "Topic": "String",
        "Problem": "Minimum number of swaps for bracket balancing.",
        "Done": false,
        "Bookmark": false,
        "Notes": "",
        "URL": "https://practice.geeksforgeeks.org/problems/minimum-swaps-for-bracket-balancing/0",
        "URL2": "https://www.codingninjas.com/codestudio/problems/minimum-number-of-swaps-for-bracket-balancing_1115682?topList=love-babbar-dsa-sheet-problems"
    },
    {
        "Id":34,
        "Topic": "String",
        "Problem": "Find the longest common subsequence between two strings.",
        "Done": false,
        "Bookmark": false,
        "Notes": "",
        "URL": "https://practice.geeksforgeeks.org/problems/longest-common-subsequence/0",
        "URL2": "https://www.codingninjas.com/codestudio/problems/longest-common-subsequence_1063255?topList=love-babbar-dsa-sheet-problems"
    },
    {
        "Id":35,
        "Topic": "String",
        "Problem": "Program to generate all possible valid IP addresses from given  string.",
        "Done": false,
        "Bookmark": false,
        "Notes": "",
        "URL": "https://www.geeksforgeeks.org/program-generate-possible-valid-ip-addresses-given-string/",
        "URL2": "https://www.codingninjas.com/codestudio/problems/ip-address_992846?topList=love-babbar-dsa-sheet-problems"
    },
    {
        "Id":36,
        "Topic": "String",
        "Problem": "Write a program to find the smallest window that contains all characters of string itself.",
        "Done": false,
        "Bookmark": false,
        "Notes": "",
        "URL": "https://practice.geeksforgeeks.org/problems/smallest-distant-window/0",
        "URL2": "https://www.codingninjas.com/codestudio/problems/shortest-substring-with-all-characters_704894?topList=love-babbar-dsa-sheet-problems"
    },
    {
        "Id":37,
        "Topic": "String",
        "Problem": "Rearrange characters in a string such that no two adjacent are same",
        "Done": false,
        "Bookmark": false,
        "Notes": "",
        "URL": "https://practice.geeksforgeeks.org/problems/rearrange-characters4649/1",
        "URL2": "https://www.codingninjas.com/codestudio/problems/rearrange-string_982765?topList=love-babbar-dsa-sheet-problems"
    },
    {
        "Id":38,
        "Topic": "String",
        "Problem": "Minimum characters to be added at front to make string palindrome",
        "Done": false,
        "Bookmark": false,
        "Notes": "",
        "URL": "https://www.geeksforgeeks.org/minimum-characters-added-front-make-string-palindrome/",
        "URL2": "https://www.codingninjas.com/codestudio/problems/minimum-characters-for-palindrome_893000?topList=love-babbar-dsa-sheet-problems"
    },
    {
        "Id":39,
        "Topic": "String",
        "Problem": "Given a sequence of words, print all anagrams together",
        "Done": false,
        "Bookmark": false,
        "Notes": "",
        "URL": "https://practice.geeksforgeeks.org/problems/k-anagrams-1/0",
        "URL2": "https://www.codingninjas.com/codestudio/problems/group-anagrams-together_985354?topList=love-babbar-dsa-sheet-problems"
    },
    {
        "Id":40,
        "Topic": "String",
        "Problem": "Find the smallest window in a string containing all characters of another string",
        "Done": false,
        "Bookmark": false,
        "Notes": "",
        "URL": "https://practice.geeksforgeeks.org/problems/smallest-window-in-a-string-containing-all-the-characters-of-another-string/0",
        "URL2": "https://www.codingninjas.com/codestudio/problems/smallest-window-in-string-containing-all-the-characters-of-another-string_981175?topList=love-babbar-dsa-sheet-problems"
    },
    {
        "Id":41,
        "Topic": "String",
        "Problem": "Recursively remove all adjacent duplicates",
        "Done": false,
        "Bookmark": false,
        "Notes": "",
        "URL": "https://practice.geeksforgeeks.org/problems/consecutive-elements/0",
        "URL2": "https://www.codingninjas.com/codestudio/problems/remove-consecutive-duplicates_893195?topList=love-babbar-dsa-sheet-problems"
    },
    {
        "Id":42,
        "Topic": "String",
        "Problem": "String matching where one string contains wildcard characters",
        "Done": false,
        "Bookmark": false,
        "Notes": "",
        "URL": "https://practice.geeksforgeeks.org/problems/wildcard-string-matching/0",
        "URL2": "https://www.codingninjas.com/codestudio/problems/wildcard-pattern-matching_701650?topList=love-babbar-dsa-sheet-problems"
    },
    {
        "Id":43,
        "Topic": "String",
        "Problem": "Function to find Number of customers who could not get a computer",
        "Done": false,
        "Bookmark": false,
        "Notes": "",
        "URL": "https://www.geeksforgeeks.org/function-to-find-number-of-customers-who-could-not-get-a-computer/",
        "URL2": "https://www.codingninjas.com/codestudio/problems/count-customers-who-did-not-get-a-computer_1115775?topList=love-babbar-dsa-sheet-problems"
    },
];

export default Strings;